<template>
  <div>
    <div class="rever-display-item" v-for="(i, index) in list" :key="index">
      <div class="label">{{i.label}}</div>
      <div class="value">{{i.value}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReverseDisplayItem',
  props: [
    'list',
  ],
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
<style scoped>
.rever-display-item {
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 11px 16px;
  color: #2F3133;
  font-size: 16px;
}
.rever-display-item .label {
  font-size: 14px;
  color: #46494D;
}
</style>
